// Filter IDs match the values already used as filter.id in withLELibraryFilters HOC.
// Re-exporting from Course/Constants/StringConstants keeps a single source of truth.
export {
  FILTER_NAME_GRADES as FILTER_ID_GRADES,
  FILTER_NAME_SUBJECTS as FILTER_ID_SUBJECTS,
  FILTER_NAME_ACADEMIC_YEAR as FILTER_ID_ACADEMIC_YEARS,
} from "Course/Constants/StringConstants";

export const FILTER_ID_CURRICULUM_PROGRAMS = "curriculumProgramIds";

export const FEATURE_FLAG_KEY = "FeatureFlag:AITutorAwards";
export const NOMINATE_FEATURE_FLAG_KEY =
  "FeatureFlag:AITutorAwardsNominateColleague";

export const PAGE_SIZE = 16;

export const SEARCH_DEBOUNCE_MS = 300;

export const I18N_NAMESPACE = "aiTutorAwards";

export const DEEP_LINK_OPEN_PARAM = "aiTutorAwards";
export const DEEP_LINK_OPEN_VALUE = "open";
export const DEEP_LINK_NOMINATE_VALUE = "open-nominate";
export const DEEP_LINK_SESSION_KEY = "aiTutorAwardsDeepLinkIntent";

// Re-uses the DemoDayBanner closed setting so closing the AI Tutor Awards
// banner also keeps the homepage banner slot dismissed across sessions.
export const BANNER_CLOSED_SETTING_NAME =
  "TeacherPortal:closeHomePageDemoDayBanner";

export const CATEGORY_OPTIONS = [
  { value: "Math", labelKey: "aiTutorAwards:impact_category_math" },
  { value: "ELA", labelKey: "aiTutorAwards:impact_category_ela" },
  { value: "Science", labelKey: "aiTutorAwards:impact_category_science" },
  {
    value: "World Languages",
    labelKey: "aiTutorAwards:impact_category_world_languages",
  },
  {
    value: "Social Sciences",
    labelKey: "aiTutorAwards:impact_category_social_sciences",
  },
  {
    value: "Computer Science",
    labelKey: "aiTutorAwards:impact_category_computer_science",
  },
  {
    value: "Other subjects",
    labelKey: "aiTutorAwards:impact_category_unsure",
  },
];

export const SPECIAL_OPTION_OTHER = "Something else";

export const SPECIAL_OPTIONS = [
  {
    value:
      "It helped me teach something in a creative, unexpected, and engaging way",
    labelKey: "aiTutorAwards:impact_special_creative",
  },
  {
    value:
      "It helped meaningfully differentiate across language, learning needs, and ability levels",
    labelKey: "aiTutorAwards:impact_special_differentiation",
  },
  {
    value: "It reached a student I was struggling to reach",
    labelKey: "aiTutorAwards:impact_special_reached_student",
  },
  {
    value: "It accelerated learning — what used to take weeks took days",
    labelKey: "aiTutorAwards:impact_special_accelerated",
  },
  {
    value: "It changed how I teach this topic entirely",
    labelKey: "aiTutorAwards:impact_special_changed_teaching",
  },
  {
    value: SPECIAL_OPTION_OTHER,
    labelKey: "aiTutorAwards:impact_special_other",
  },
];

const DRAFT_KEY_PREFIX = "aiTutorAwards_draft_";

export const getDraftKey = userId => `${DRAFT_KEY_PREFIX}${userId || "anon"}`;

export const AI_TUTOR_AWARDS_SHARE_URL =
  "https://www.toddleapp.com/toddle-ai-tutor-awards-2026/";
